import { AbstractControl, ValidationErrors } from "@angular/forms";
import { isPhoneNumber } from 'class-validator';

export const isPhoneNumberValidator = (control: AbstractControl): ValidationErrors | null => {
    return control.value !== "" && !isPhoneNumber(control.value) ? { phone: 'invalid' } : null;
}